var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationSmartscan = function SvgSimpleIllustrationSmartscan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.786 15.479H5.178a2.004 2.004 0 0 0-2.004 2.004v20.513c0 1.107.897 2.004 2.004 2.004h37.608a2.004 2.004 0 0 0 2.004-2.004V17.482a2.004 2.004 0 0 0-2.004-2.003Z",
    fill: "#F25730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.455 15.37H5.395A2.396 2.396 0 0 0 3 17.766v19.717a2.396 2.396 0 0 0 2.396 2.396h37.06a2.396 2.396 0 0 0 2.395-2.396V17.766a2.396 2.396 0 0 0-2.396-2.396ZM6.947 35.888l5.659-.002M15.2 35.887h5.659",
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.395 26.669h-.984a.464.464 0 0 0-.463.464v1.793c0 .256.207.464.463.464h.984a.464.464 0 0 0 .463-.464v-1.793a.464.464 0 0 0-.463-.464ZM13.42 23.939h-.983a.464.464 0 0 0-.464.463v1.33c0 .256.208.464.464.464h.983a.464.464 0 0 0 .464-.464v-1.33a.464.464 0 0 0-.464-.463ZM15.842 27.105h-.983a.464.464 0 0 0-.464.463v1.33c0 .256.208.464.464.464h.983a.464.464 0 0 0 .464-.464v-1.33a.464.464 0 0 0-.464-.463ZM15.783 23.939H14.8a.464.464 0 0 0-.464.463v1.91c0 .257.208.464.464.464h.983a.464.464 0 0 0 .464-.463v-1.91a.464.464 0 0 0-.464-.464ZM11.488 28.932v-4.615a.432.432 0 0 0-.434-.433l-1.578-.001a.436.436 0 0 0-.344.167l-.537.691a.453.453 0 0 0-.093.266l-.001 3.35a.43.43 0 0 0 .077.247l.403.579a.437.437 0 0 0 .36.185l1.712-.006a.438.438 0 0 0 .434-.435l.001.005Z",
    fill: "#F5D5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.724 23.51H24.792c-1.084 0-1.964.88-1.964 1.965v1.641c0 1.085.88 1.964 1.964 1.964h13.932c1.085 0 1.964-.88 1.964-1.964v-1.641c0-1.085-.88-1.964-1.964-1.964Z",
    fill: "#002140"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.833 21.381a6.1 6.1 0 1 0 0-12.2 6.1 6.1 0 0 0 0 12.2Z",
    fill: "#FFFAF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.056 21.47a6.1 6.1 0 1 0 0-12.2 6.1 6.1 0 0 0 0 12.2Z",
    fill: "#FFFAF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.684 13.483s-1.887-4.245-4.834-4.421C32.903 8.886 30.9 10.24 30.9 10.24S29.07 9 26.419 9.178c-2.651.178-5.039 2.622-5.364 4.362 0 0 1.532 1.24 4.125 1.24s3.36-.177 3.36-.177l.414-1.239s3.477 1.708 6.662 1.591c3.184-.117 5.068-1.473 5.068-1.473Z",
    fill: "#D08000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.105 10.26a6.128 6.128 0 0 1 9.852 4.869 6.13 6.13 0 1 1-9.852-4.871",
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.827 19.913a6.1 6.1 0 0 1-3.837 1.348 6.13 6.13 0 1 1 3.707-11.011",
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.053 13.6s4.303 2.651 11.613 0M21.095 13.6s2.71 1.67 7.483 1.034",
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m35.477 17.903-2.646.538a3.418 3.418 0 0 0 3.355 2.761c1.89 0 3.42-1.53 3.42-3.419a3.418 3.418 0 0 0-6.396-1.679l2.27 1.797-.002.002ZM30.585 20.142a3.42 3.42 0 0 1-5.772-1.759l2.646-.538-2.27-1.796a3.414 3.414 0 0 1 3.666-1.671s-.628 3.821 1.727 5.116",
    fill: "#002140"
  })));
};
export default SvgSimpleIllustrationSmartscan;